// ページトップボタンの表示制御とスクロール動作を実装
export function initPageTop() {
  'use strict';

  // ページトップボタンの要素を取得する
  const pageTopButton = document.getElementById('pageTop');

  // 要素が見つからない場合は処理を中断する
  if (!pageTopButton) {
    return;
  }

  // ページトップボタンをクリックしたとき、ページ最上部へスムーズスクロールする関数
  const onClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // 'smooth' を指定するとアニメーションしながらスクロールする
    });
  };

  // イベントリスナーを登録する
  pageTopButton.addEventListener('click', onClick);
}